import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { ConfigService, OrderableItem, StoreConfig } from 'ngx-web-api';
import { filter, takeUntil } from 'rxjs/operators';
import { ItemEditorService } from '../../core/services/item-editor.service';
import { MenuWrapperService } from '../../core/services/menu-wrapper.service';
import { SpecialWizardEditingItemChoicesService } from '../../core/services/special-wizard-editing-item-choices.service';
import { SpecialWizardStep } from '../../domain/special-wizard-step';
import { Subject } from 'rxjs';
import { BreakpointService } from '../../core/services/breakpoint.service';
import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons';
import { ThemeService } from 'app/core/services/theme.service';
import { Theme } from 'app/domain/theme.model';
import { IngredientSelection } from 'app/domain/ingredient-selection';
import { OrderingUtilsService } from 'app/core/services/ordering-utils.service';

@Component({
  selector: 'fts-special-wizard-item-editor',
  templateUrl: './special-wizard-item-editor.component.html',
  styleUrls: ['./special-wizard-item-editor.component.scss'],
})
export class SpecialWizardItemEditorComponent implements OnChanges, OnDestroy {
  @Input()
  currentStep: SpecialWizardStep;

  destroy$: Subject<void> = new Subject<void>();
  faAngleDoubleLeft = faAngleDoubleLeft;
  theme: Theme;
  formattedNoticePeriod: string = '';
  noticePeriod: number = 0;
  hasCateringNoticeTime: boolean;

  public calories?: string;

  constructor(
    private menuService: MenuWrapperService,
    private itemEditorService: ItemEditorService,
    private specialWizardEditingItemChoices: SpecialWizardEditingItemChoicesService,
    private themeService: ThemeService,
    public breakPointService: BreakpointService,
    private orderingUtilsService: OrderingUtilsService,
    private configService: ConfigService
  ) {
    this.configService.storeConfig$.subscribe((config: StoreConfig) => (this.hasCateringNoticeTime = config?.hasCateringNoticeTime));
    this.themeService.theme.pipe(takeUntil(this.destroy$)).subscribe(theme => (this.theme = theme));
    this.itemEditorService.editingOrderableItem$
      .pipe(
        filter(() => !!this.currentStep),
        takeUntil(this.destroy$)
      )
      .subscribe((item: OrderableItem) => {
        this.currentStep.selectedOrderableItem = item;
        this.calcCalories();
        this.noticePeriod = item.getSizePrice(this.currentStep?.selectedOrderedItem?.size)?.noticePeriod;
        this.formattedNoticePeriod = this.orderingUtilsService.formatNoticePeriod(this.noticePeriod);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentStep'] && this.currentStep && this.currentStep.selectedOrderableItem && this.currentStep.selectedOrderedItem) {
      this.itemEditorService.updateEditingItem(this.currentStep.selectedOrderableItem, this.currentStep.selectedOrderedItem);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeItem() {
    this.specialWizardEditingItemChoices.setVisibleOrderedChoice(undefined);
    this.specialWizardEditingItemChoices.setVisibleChoice(undefined);
    this.currentStep.reset();
  }

  onIngredientChanged(_: IngredientSelection[]) {
    this.currentStep.selectedOrderedItem = this.currentStep.selectedOrderedItem.copy();
  }

  private calcCalories(): void {
    const selectedSizePrice = this.currentStep.selectedOrderableItem.sizePrices.find(
      s => s.size === this.currentStep.selectedOrderedItem.size
    );
    this.calories = this.menuService.getItemCalories(selectedSizePrice, this.currentStep.selectedOrderableItem.showFullSizeCalories);
  }
}
